// Card Dati Fornitura: upload bolletta con estrazione AI, dati fornitura, consumi e dati impianto
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Separator } from '../../ui/separator';
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../ui/select';
import { Receipt, Upload, Sparkle, CircleNotch } from '@phosphor-icons/react';
import { ConsumiSection } from './ConsumiSection';
import { PlantDataSection } from './PlantDataSection';

export const SupplyDataCard = ({
    quote, isEditable, extractingBill, onBillUpload,
    onUpdateSupplyData, onUpdateQuote, calculatedPlantData,
}) => (
    <Card>
        <CardHeader>
            <CardTitle className="flex items-center gap-2">
                <Receipt className="w-5 h-5" />
                Dati Fornitura
            </CardTitle>
            <CardDescription>
                Carica una bolletta per estrarre automaticamente i dati di consumo
            </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
            {/* Upload Bolletta */}
            {isEditable && (
                <div className="border-2 border-dashed rounded-lg p-4 text-center">
                    <input
                        type="file"
                        id="bill-upload"
                        className="hidden"
                        accept="image/jpeg,image/png,image/webp,application/pdf"
                        onChange={onBillUpload}
                        disabled={extractingBill}
                    />
                    <label
                        htmlFor="bill-upload"
                        className={`cursor-pointer flex flex-col items-center gap-2 ${extractingBill ? 'opacity-50' : ''}`}
                    >
                        {extractingBill ? (
                            <>
                                <CircleNotch className="w-8 h-8 text-blue-500 animate-spin" />
                                <span className="text-sm text-blue-600">Analisi AI in corso...</span>
                            </>
                        ) : (
                            <>
                                <div className="flex items-center gap-2">
                                    <Upload className="w-6 h-6 text-zinc-400" />
                                    <Sparkle className="w-4 h-4 text-amber-500" />
                                </div>
                                <span className="text-sm text-zinc-600">
                                    Carica bolletta (JPG, PNG, PDF)
                                </span>
                                <span className="text-xs text-zinc-400">
                                    I dati verranno estratti automaticamente con AI
                                </span>
                            </>
                        )}
                    </label>
                </div>
            )}

            {/* Dati Fornitura Estratti/Manuali */}
            <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                    <Label>POD</Label>
                    <Input
                        value={quote.supply_data?.pod || ''}
                        onChange={(e) => onUpdateSupplyData('pod', e.target.value)}
                        placeholder="IT001E..."
                        disabled={!isEditable}
                    />
                </div>
                <div className="space-y-2">
                    <Label>Potenza Impegnata (kW)</Label>
                    <Input
                        type="number"
                        step="0.5"
                        value={quote.supply_data?.potenza_impegnata_kw || ''}
                        onChange={(e) => onUpdateSupplyData('potenza_impegnata_kw', parseFloat(e.target.value))}
                        placeholder="3.0"
                        disabled={!isEditable}
                    />
                </div>
                <div className="space-y-2">
                    <Label>Tipo Tariffa</Label>
                    {isEditable ? (
                        <Select
                            value={quote.supply_data?.tipo_tariffa || ''}
                            onValueChange={(v) => onUpdateSupplyData('tipo_tariffa', v)}
                        >
                            <SelectTrigger>
                                <SelectValue placeholder="Seleziona..." />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="monoraria">Monoraria</SelectItem>
                                <SelectItem value="bioraria">Bioraria</SelectItem>
                                <SelectItem value="trioraria">Trioraria</SelectItem>
                            </SelectContent>
                        </Select>
                    ) : (
                        <p className="p-2 bg-zinc-50 rounded capitalize">{quote.supply_data?.tipo_tariffa || '-'}</p>
                    )}
                </div>
                <div className="space-y-2">
                    <Label>Fornitore</Label>
                    <Input
                        value={quote.supply_data?.fornitore || ''}
                        onChange={(e) => onUpdateSupplyData('fornitore', e.target.value)}
                        placeholder="Enel, Eni, etc."
                        disabled={!isEditable}
                    />
                </div>
            </div>

            <Separator />

            <ConsumiSection
                quote={quote}
                isEditable={isEditable}
                onUpdateSupplyData={onUpdateSupplyData}
                onUpdateQuote={onUpdateQuote}
            />

            <Separator />

            <PlantDataSection
                quote={quote}
                isEditable={isEditable}
                onUpdateQuote={onUpdateQuote}
                calculatedPlantData={calculatedPlantData}
            />
        </CardContent>
    </Card>
);
